import Swiper, { Navigation, Pagination, Controller, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Controller, Autoplay]);
export default class ShortContent {
    constructor(elm, args) {
        const allVideos = elm.querySelectorAll('video');
        allVideos.forEach(video => video.addEventListener('loadeddata', () => {
            video.closest('.short-content__image-container__video--has-thumbnail')?.classList.add('short-content__image-container__video--loaded');
        }));

        const swiperElem = elm.querySelector('.swiper-container');
        const creditContainer = elm.querySelector('[data-credit-container]');
        const options = {
            loop: true,
            autoHeight: false,
            lazy: false,
            speed: 700,
            spaceBetween: 20,
            pagination: {
                el: elm.querySelector('.swiper-pagination'),
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return (number < 10 ? '0' : '') + number;
                },
                formatFractionTotal: function (number) {
                    return (number < 10 ? '0' : '') + number;
                },
            },
            on: {
                slideChange: function (x) {
                    window.loadResource({ target: swiperElem });
                    const slide = x?.slides[x?.activeIndex];
                    creditContainer.innerHTML = slide.dataset.creditText || '&nbsp;';
                },
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: elm.querySelector('.swiper-button-next'),
                prevEl: elm.querySelector('.swiper-button-prev'),
            },
            ...args,
        };

        this.swiper = new Swiper(swiperElem, options);
    }

}
